<script setup lang="ts">
/**
 * The one line a decision card leads with (#1760): what the decision is, then the recommendation when the gate
 * carries one, so the card reads in a glance and its reasoning can fold away under "Show details". It never invents
 * a recommendation: with none given there is no recommendation line.
 *
 * Marked `data-lead`, the one lead on a card, wherever it is drawn (Needs you, chat, the run page).
 */
defineProps<{
    /** The lead line itself: the summary's first line, who is asking and how many questions, or what changes. */
    line: string
    /** The recommendation the gate carries, in its own words. None when it carries none. */
    recommendation?: string | null
}>()
</script>

<template>
    <div class="zh-decision-lead" data-lead>
        <p class="zh-decision-lead__line">{{ line }}</p>
        <p v-if="recommendation" class="zh-decision-lead__recommendation">
            <span class="zh-decision-lead__label">Recommendation</span>
            {{ recommendation }}
        </p>
    </div>
</template>

<style scoped>
p {
    margin: 0;
}

.zh-decision-lead {
    display: grid;
    gap: 0.25rem;
}

.zh-decision-lead__line {
    color: var(--ink-1);
    font-size: 0.9375rem;
    font-weight: 500;
    overflow-wrap: anywhere;
}

.zh-decision-lead__recommendation {
    color: var(--ink-2);
    font-size: 0.9375rem;
    overflow-wrap: anywhere;
}

/* The system label (BG §19.3), beside the words it names. */
.zh-decision-lead__label {
    margin-right: 0.375rem;
    color: var(--ink-3);
    font-family: var(--font-mono);
    font-size: 0.75rem;
    font-weight: 500;
    letter-spacing: var(--tracking-system);
    text-transform: uppercase;
}
</style>
